import React from 'react';
import { motion } from 'framer-motion';
import { TrustBadges } from '../components/TrustBadges';
import { Star, Quote } from 'lucide-react';
const reviews = [{
  text: 'Fast access and excellent variety. The cloud-based system makes reading on the go incredibly simple.',
  author: 'J. Turner',
  rating: 5
}, {
  text: "Clear pricing and simple to use. Finally a subscription service that doesn't hide fees.",
  author: 'A. Patel',
  rating: 5
}, {
  text: "Great selection and smooth experience. I've discovered so many new authors through Bluecore.",
  author: 'S. Bennett',
  rating: 5
}];
export function AboutUsPage() {
  return <main className="flex-1 bg-background" data-id="element-121">
      {/* Hero Section */}
      <section className="relative pt-16 pb-12 lg:pt-24 lg:pb-16 bg-gradient-to-br from-primary/5 to-accent/5" data-id="element-122">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-123">
          <motion.h1 initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-bold text-slate-dark mb-6" data-id="element-124">
            About Bluecore
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-125">
            We're on a mission to make digital reading accessible, efficient,
            and enjoyable for everyone.
          </motion.p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-white" data-id="element-126">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-127">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-128">
            <h2 className="text-3xl font-bold text-slate-dark mb-6" data-id="element-129">
              Our Mission
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-8" data-id="element-130">
              Bluecore provides subscription-based ebook access that helps users
              read more efficiently with a simple, cloud-based system. We
              believe that accessing knowledge shouldn't be complicated. That's
              why we've built a platform focused on clarity, organisation, and
              ease of use.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-131">
              Whether you're a casual reader or a business professional, our
              curated digital library ensures you have the right content at your
              fingertips, whenever you need it.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-20 bg-slate-50" data-id="element-132">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
          <div className="text-center mb-16" data-id="element-134">
            <h2 className="text-3xl font-bold text-slate-dark mb-4" data-id="element-135">
              What Our Readers Say
            </h2>
            <p className="text-slate-600" data-id="element-136">Trusted by readers across the UK</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-137">
            {reviews.map((review, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2,
            duration: 0.5
          }} className="bg-white p-8 rounded-xl shadow-sm border border-slate-100 relative" data-id="element-138">
                <Quote className="w-8 h-8 text-accent/20 mb-4" data-id="element-139" />
                <div className="flex gap-1 mb-4" data-id="element-140">
                  {[...Array(review.rating)].map((_, i) => <Star key={i} className="w-4 h-4 text-accent fill-current" data-id="element-141" />)}
                </div>
                <p className="text-slate-600 mb-6 italic" data-id="element-142">"{review.text}"</p>
                <div className="font-bold text-slate-dark border-t border-slate-100 pt-4" data-id="element-143">
                  — {review.author}
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Trust Badges */}
      <section className="py-16 bg-white border-t border-slate-100" data-id="element-144">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-145">
          <TrustBadges data-id="element-146" />
        </div>
      </section>
    </main>;
}